module.exports = __webpack_public_path__ + "static/media/logo.9ed87480.png";